import React from 'react';

// Public, no-login route — same tier as /print/* and /ssg/tv in App.js.
export default function Terms() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-app)', color: 'var(--text-primary)', fontFamily: 'Inter, sans-serif' }}>
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '48px 24px 80px', lineHeight: 1.7, color: 'var(--text-secondary)' }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 4, color: 'var(--text-primary)' }}>HeraLabX — Terms of Service</h1>
        {/* Source doc left this as a "[date]" placeholder -- filled in to match the privacy
            policy's Last updated date; flag to Frederik if a different date is wanted. */}
        <p style={{ color: 'var(--text-muted)', fontSize: 14, marginBottom: 32 }}><strong>Last updated:</strong> 24/09/2026</p>

        <h2 style={h2}>What this is</h2>
        <p>HeraLabX is an internal software platform built and operated by Heracles Almelo (the "Club") for use by its own players and performance/medical staff. It is not a public product and is not offered to anyone outside the Club.</p>

        <h2 style={h2}>Who can use it</h2>
        <p>Access is limited to current Heracles Almelo players and staff who have been given an account. Access ends when your relationship with the Club ends, and any linked third-party connections (such as an Oura account) are disconnected at that point.</p>

        <h2 style={h2}>What it's for</h2>
        <p>HeraLabX supports training load monitoring, wellness tracking and performance analysis for the Club's performance and medical departments. It is provided for that internal purpose only.</p>

        <h2 style={h2}>Third-party integrations</h2>
        <p>HeraLabX can connect to third-party services you authorize, including Oura, to receive data you choose to share. Your use of those third-party services remains subject to that provider's own terms. The Club is not responsible for the availability or accuracy of third-party services.</p>

        <h2 style={h2}>No warranty</h2>
        <p>HeraLabX is provided "as is," on a best-effort basis, without warranty of any kind. It is built and maintained internally and may be unavailable or contain errors from time to time.</p>

        <h2 style={h2}>Liability</h2>
        <p>To the extent permitted by Dutch law, Heracles Almelo is not liable for indirect or consequential loss arising from the use of, or inability to use, HeraLabX. This does not limit any rights you have as an employee under your employment contract or Dutch law.</p>

        <h2 style={h2}>Changes</h2>
        <p>The Club may update these terms from time to time. Material changes affecting players will be communicated directly.</p>

        <h2 style={h2}>Governing law</h2>
        <p>These terms are governed by the laws of the Netherlands.</p>

        <h2 style={h2}>Contact</h2>
        <p>Questions about these terms: <a href="mailto:f.vandijck@heracles.nl" style={link}>f.vandijck@heracles.nl</a></p>
      </div>
    </div>
  );
}

const h2 = { fontSize: 18, fontWeight: 700, marginTop: 32, marginBottom: 10, color: 'var(--text-primary)' };
const link = { color: '#3b82f6' };
